import 'jquery';
import 'jquery-ui/ui/widgets/selectable';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';

import 'jquery.atwho';
import 'jquery.caret';

import './wd-smartbanner';
import 'blueimp-file-upload';
import 'bowser';
import 'remarkable';
import 'lodash-es';
import 'angular';
import 'angular-animate';
import 'angular-route';
import 'angular-sanitize';
import 'angular-ui-bootstrap';
import 'angular-bindonce';

import 'ui-select';
import 'ui-select/dist/select.css';
import '../vendor/select2/select2.css';

import 'angular-translate';
import 'messageformat';
import 'angular-translate-interpolation-messageformat';
import '../vendor/locale';

import 'angular-local-storage';
import 'angular-ui-date';
import 'angular-aside-menu';
import 'angular-dropdown-multiselect';

import 'search-query-parser';

import 'angular-websocket';


import 'moment';

import '../styles/angular-ui.min.css';
import '../styles/work-docs-icon.scss';
import '../styles/app.scss';

import "./allModules";

import './pre-angular/EndpointConfig';

import './templates';

import './admin/module';
import './admin/gbDomainListDirective';
import './admin/AdministrationController';
import './admin/workdrives/module';
import './admin/workdrives/AdminWDController';

import "./shared/utils";
import "./utils/AngularUtils";
import "./shared/EventEmitter";

import "./document-viewer/DocViewerBridge";
import "./services/services";
import "./app.module";
import "./filters/filters";
import "./gorillaboy/gorillaboy-source";
import "./gorillaboy/gorillaboy-rights";
import "./gorillaboy/AppConstants";
import "./gorillaboy/UIEvents";
import "./gorillaboy/MessageProvider";
import "./gorillaboy/SignalProvider";
import "./gorillaboy/TranslateFactory";
import "./gorillaboy/gorillaboy-locale";
import "./services/PathManager";
import "./services/FileUploadService";
import "./services/MessageManager";
import "./services/DateTimeService";
import "./services/BaseService";
import "./services/BaseHttpService";
import "./services/DocumentService";
import "./services/PurgeVersionService";
import "./services/FeedbackService";
import "./services/FeedbackLocalStorageService";
import "./services/AnalyticsService";
import "./services/AnnotationService";
import "./services/DocumentStateService";
import "./services/DocumentUtilities";
import "./services/EndpointService";
import "./services/FileCountService";
import "./services/formatters/ContentTypeFormatter";
import "./services/formatters/DateFormatter";
import "./services/InviteService";
import "./services/LayoutManager";
import "./services/PreferencesService";
import "./services/PromiseWatcherService";
import "./services/RegionService";
import "./services/SearchService";
import "./services/SearchV2Service";
import "./services/SessionManager";
import "./services/SortService";
import "./services/TokenService";
import "./services/UserService";
import "./services/ResourceService";
import "./services/UserCollectionService";
import "./services/GroupCollectionService";
import "./services/GroupService";
import "./services/CompanionService";
import "./services/AccessControlService";
import "./services/ResourceIconService";
import "./services/ShareLinkService";
import "./services/AuditEmailService";

import "./directives/directives";
import "./directives/clickStreamMetrics";
import "./directives/gbSidebarResizingControl";
import "./directives/floatingContainer";
import "./directives/showMoreLess";
import "./directives/layout";
import "./directives/user";
import "./directives/multiSelect";
import "./directives/hideHeaderDirectives";
import "./directives/lockAndEditDirective";
import "./directives/infoBoxStyleDirective";
import "./directives/permissionPanelDirective";
import "./directives/audioPlayerDirective";
import "./directives/dropdownSubmenuAutoAlign";

import "./shared/ModalFactory";
import "./shared/ServiceHelper";
import "./shared/AuthService";
import "./shared/RetryInterceptor";
import "./shared/LoggingHttpInterceptor";

import "./shared/FileService";
import "./shared/OrganizationService";
import "./shared/TypeaheadService";
import "./shared/personEntryDirective";
import "./shared/detailedGroupEntryDirective";
import "./shared/contributorEntryDirective";
import "./shared/gbBootstrapTypeahead";
import "./shared/uploadPaneController";
import "./shared/DocumentDropdownController";
import "./shared/DocumentSourceUrlController"
import "./shared/FilterSharedByMeResourceController";
import "./shared/ResourceRenameModalCtrl";
import "./shared/IpWhitelistingController";
import "./shared/ingressModal/ingressModal";
// --=== Login ===--
import "./login/module";
import "./login/GenericErrorController";
import "./login/LoginController";
import "./login/OAuth2CallbackController";
import "./login/AuthSuccessController";
import "./login/InviteController";
import "./login/LoginFailedController";

// --=== Feature manager ===--
import "./feature-manager/Features";
import "./feature-manager/featureManagerDirective";
import "./feature-manager/FeatureManagerService";

// --=== Feature notification ===--
import "./feature-notification/FeatureNotificationDirective"
import "./feature-notification/FeatureNotificationService"

// --=== Client Metrics ===--
import "./client-metrics/module";
import "./client-metrics/ClientMetricsService";
import "./client-metrics/LogDecorator";

import "./shared/CheckinCheckoutController";
import "./shared/RequestCheckinModalController";
import "./shared/ProprietorDiscardCheckoutModalController";

// --=== File Browser ===--
import "./file-browser/module";
import "./file-browser/FavoritesService";
import "./file-browser/BaseFileBrowserController";
import "./file-browser/FileManager";

import "./file-browser/FileBrowserControllerUpload";
import "./file-browser/FileBrowserController";
import "./file-browser/MigrationController";
import "./file-browser/FilesRightPanelController";
import "./file-browser/gbFileBrowserListView";
import "./file-browser/gbFileBrowserThumbnailView";
import "./file-browser/StringHashSet";
import "./file-browser/fileBrowserUploadController";
import "./file-browser/rightClickMenuDirective"

// --=== Tasks view ===--
import "./tasks/module";
import "./tasks/TasksController";
import "./tasks/NewTaskController";
import "./tasks/TasksService";
import "./tasks/list_view.html";

// --=== dboard view ===--
import "./dboard/module";
import "./dboard/dboardController";


// --=== move modal ===--
import "./move-modal/moveModal";
import "./move-modal/subFolderListDirective";

// --=== transfer modal ===--
import "./transfer-modal/transferModal";

// --=== Migrate home drive ===--
import "./migrate-home-drive/content_partial.html";
import "./migrate-home-drive/title_bar.html";
import "./migrate-home-drive/migrationIframe";

// --=== left nav ===--
import "./left-nav/LogoService";

// --=== right panel ===--
import "./right-panel/rightDirective";
import "./right-panel/fileBrowserRightPanel";
import "./right-panel/documentViewerRightPanel";

// --=== search ===--
import "./search/module";
import "./search/search.html";
import "./search/searchDirective";
import "./search/search_menu.html";
import "./search/searchMenuDirective";
import "./search/SearchController";
import "./search/QuerySearchManager";
import "./search/SearchCommons";

// --=== Document Viewer ===--
import "./document-viewer/module";
import "./document-viewer/DocumentController";
import "./document-viewer/QuartzDocumentController";
import "./document-viewer/FeedbackSyncService";
import "./document-viewer/DocumentModalsController";
import "./document-viewer/DocumentTitleBarController";
import "./document-viewer/PurgeVersionsModal";
import "./document-viewer/DocumentFeedbackFilterPanelController";
import "./document-viewer/DocumentRightPanelController";
import "./document-viewer/documentDirectives";
import "./document-viewer/feedbackSidebar";
import "./document-viewer/documentVersionFeedback";
import "./document-viewer/feedbackDirectives";
import "./document-viewer/feedbackInputComponent";
import "./document-viewer/pdfRenderDirective";
import "./document-viewer/GetNextDocumentService";
import "./document-viewer/documentViewUploadController";
import "./document-viewer/passcodeController";
import "./document-viewer/PurgeDocumentVersionController";


// --=== Office Document Editor ===--
import "./office-editor/module";
import "./office-editor/OfficeFormSubmitterDirective";
import "./office-editor/OfficeFormMessageHandler";
import "./office-editor/OfficeEditorController";
import "./office-editor/WopiService";



// --=== Share modal ===--
import "./share-modal/module";
import "./share-modal/gbShareModal";
import "./share-modal/gbShareLinkModal";
import "./share-modal/sendMessageModal";
import "./share-modal/gbTimepickerDirective";
import "./share-modal/gbEmailSelectDirective";
import "./share-modal/createFolderModal";

// --=== Tutorial ===--
import "./tutorial/didYouKnowMessage";
import "./tutorial/DidYouKnowMessagesService";

// -=== Native render utils ====-
import "./document-viewer/NativeRenderingUtils";

// --=== User Profile ===--
import "./top-nav/gbProfileInputDirective";

// --=== Gorillaboy Admin Code ===--
import "./shared/gbOrgUserSelectDirective";

// --=== Gorillaboy Admin WorkDrives Code ===--

// --=== edit modal ===--
import "./edit-modal/gbEditModal";
import "./edit-modal/gbFrictionlessEditModal";
import "./edit-modal/gbEditResultModal";

// --=== Gorillaboy Analytics Code ===--
import "./analytics/module";
import "./analytics/AnalyticsController";
import "./analytics/activitiesDirectives";
import "./analytics/exportButtonTooltip.html";

// --=== Gorillaboy Dashboard Code ===--
import "./dashboard/module";
import "./dashboard/DashboardController";

import './admin/content_partial.html';
import './admin/modals.html';
import './admin/title_bar.html';
import './admin/storage_used.html';
import "./admin/workdrives/content_partial.html";
import "./admin/workdrives/title_bar.html";
import "./admin/exportUsersButtonTooltip.html";
import "./analytics/content_partial.html";
import "./analytics/title_bar.html";
import "./assets/partials/app/layout.html";
import "./assets/partials/typeahead/typeahead_item.html";
import "./assets/partials/typeahead/typeahead_match.html";
import "./assets/partials/typeahead/typeahead_popup.html";

import "./common/directives/wd-form-control-directives";
import "./common/templates/wd-action.html";
import "./common/templates/wd-button.html";
import "./common/templates/wd-link.html";

import "./dashboard/content_partial.html";
import "./dashboard/title_bar.html";
import "./document-viewer/feedback_comment_entry.html";
import "./document-viewer/feedback_annotation_entry.html";

import "./document-viewer/content_partial.html";
import "./document-viewer/documentViewEditDisabledTooltip.html";
import "./document-viewer/feedback.html";
import "./document-viewer/feedback_annotation_entry.html";
import "./document-viewer/feedback_comment_entry.html";
import "./document-viewer/feedback_filter_menu.html";
import "./document-viewer/feedback_input.html";
import "./document-viewer/feedback_input_component.html";
import "./document-viewer/feedback_list_view.html";
import "./document-viewer/modals.html";
import "./document-viewer/passcode_modal.html";
import "./document-viewer/right_panel.html";
import "./document-viewer/sidebar_people.html";
import "./document-viewer/sidebar_security.html";
import "./document-viewer/title_bar.html";
import "./document-viewer/version-switcher.html";
import "./document-viewer/inputHintTooltip.html";
import "./document-viewer/purge_document_version_modal.html";
import "./document-viewer/purge_prior_document_versions_modal.html";
import "./document-viewer/version_delete_modal.html";
import "./document-viewer/quartz_content_partial.html";

import "./edit-modal/edit_modal_dialog.html";
import "./edit-modal/frictionless_edit_modal_dialog.html";
import "./edit-modal/edit_result_modal_dialog.html";

import "./file-browser/note_file_list_view.html";
import "./file-browser/note_folder_list_view.html";


import "./file-browser/content_partial.html";
import "./file-browser/file_dropdown.html";
import "./file-browser/dropDownEditDisabledTooltip.html";
import "./file-browser/dropDownFolderDownloadDisabledTooltip.html";
import "./file-browser/folder_dropdown.html";
import "./file-browser/list_view_type.html";
import "./file-browser/missingResourcesModal.html";
import "./file-browser/modals.html";
import "./file-browser/onActionBarEditDisabledTooltip.html";
import "./file-browser/request_file_access.html";
import "./file-browser/right_panel.html";
import "./file-browser/sidebar_people.html";
import "./file-browser/sidebar_security.html";
import "./file-browser/thumbnail_view_type.html";
import "./file-browser/title_bar.html";
import "./login/not_active.html";
import "./login/site_not_exists_error.html";
import "./login/no_cookies.html";
import "./login/generic_error.html";
import "./login/oauth2.html";
import "./move-modal/move_dialog.html";
import "./move-modal/sub_folder_list.html";
import "./transfer-modal/transfer_dialog.html";
import "./office-editor/content_partial.html";
import "./profile/storage_used_profile.html";
import "./right-panel/right_panel.html";

import "./right-panel/right_panel_widget.html";
import "./search/search.html";

import "./share-modal/email_select.html";
import "./share-modal/send_message_dialog.html";
import "./share-modal/share_link_modal_dialog.html";
import "./share-modal/share_modal_dialog.html";
import "./share-modal/timepicker.html";

import "./shared/breadcrumb.html";
import "./shared/breadcrumbDirective";
import "./shared/actionBarDirective";
import "./shared/confirmation_modal.html";
import "./shared/contributor_entry.html";
import "./shared/detailed_group_entry.html";
import "./shared/file_upload_mask.html";
import "./shared/documentViewActionBar.html";
import "./shared/documentViewActionBarForAnonymousUsers.html"
import "./shared/fileBrowserActionBar.html";

import "./shared/person_entry.html";
import "./shared/proprietor_discard_checkout_modal.html";
import "./shared/fileBrowserActionBar.html";
import "./shared/request_checkin_modal.html";
import "./shared/sharedByMeFilterActionBar.html"
import "./shared/recycleActionBar.html";
import "./shared/recoveryActionBar.html";
import "./shared/waitingForFEClientModal.html";
import "./shared/breadcrumb_currentFolderDropdown.html"
import "./shared/ipWhitelistingModal.html";
import "./shared/lock-and-edit-modal/lock-and-edit.html";
import "./shared/lock-and-edit-modal/lockAndEditController";


import "./top-nav/NavModule";
import "./top-nav/profilePanelDirective";

import "./top-nav/profile_panel.html";
import "./top-nav/search_filters.html";
import "./top-nav/secondary-nav.html";
import "./top-nav/top_nav.html";
import "./top-nav/menu_buttons";
import "./top-nav/buttons/folderInfo_button.html";
import "./top-nav/buttons/edit_button.html";
import "./top-nav/buttons/share_button.html";
import "./top-nav/buttons/file_action_button.html";
import "./top-nav/buttons/folder_action_button.html";
import "./top-nav/buttons/current_folder_action_button.html";
import "./top-nav/buttons/new_button.html";
import "./top-nav/buttons/upload_button.html";
import "./top-nav/buttons/delete_button.html";
import "./top-nav/buttons/restore_button.html";
import "./top-nav/buttons/shared_by_me_button.html";
import "./top-nav/buttons/delete_link_button.html";
import "./top-nav/buttons/multi_select_action_button.html";
import "./top-nav/buttons/add_to_approval_button.html";

import "./top-banner/top_banner.html";
import "./top-banner/TopBannerModule";

// ==== Approvals UX ==========
import "./approvals/ApprovalUtils";
import "./approvals/approvalView/module";
import "./approvals/newApprovalRequestPanel/newApprovalRequestPanel";
import "./approvals/approvalActionBar/approvalActionBar";

// ==== Companion Client ====
import "./companionClient/companionClient";
import "./companionClient/companionClientEventHandler";
